<payee-popup [onCancel]="cancel">
  <ng-template #payeePopupTitleTemplate>
    <h1>{{ title }}</h1>
  </ng-template>
  <ng-template #payeePopupDescriptionTemplate>
    <p>{{ description }}</p>
  </ng-template>
  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      (click)="saveOnly()"
    >
      Mentés
    </button>
    @if (!autoSendOnSave) {
      <button
        payee-button
        width="max"
        color="alert-green"
        (click)="saveAndSend()"
      >
        Mentés és küldés
      </button>
    }
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      [isBorderButton]="true"
      (click)="cancel()"
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
